module.exports = __webpack_public_path__ + "static/media/image3.46534b7a.png";